module.exports = __webpack_public_path__ + "assets/banner.a12b4396.jpeg";